import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TableLoadingSkeleton } from "src/shared/components/tables/table-loading-skeleton";
import { NoData } from "src/shared/components/tables/no-data";
import { useTranslation } from "react-i18next";
import { formatNumberWithSeparators } from "src/utils";
import TableHeaderCell from "src/shared/components/table-head";
import { useLocation } from "react-router-dom";

const TransactionItemsTable = ({
  list,
  isLoading,
}: {
  list: any;
  isLoading: boolean;
}) => {
  const { t: purchasingT } = useTranslation("purchasing");
  const { t: generalT } = useTranslation("general");
  const { t: salesT } = useTranslation("addSales");
  const location = useLocation();
  const isModifier = location.pathname.includes("/modifiers");

  const tableHeadTextd = [
    purchasingT("name"),
    purchasingT("SKU"),
    generalT("netQuantity"),
    generalT("netSales"),
    generalT("cost"),
    `${generalT("cogs")} %`,
  ];

  const tableHeadText = [
    {
      label: purchasingT("name"),
    },
    {
      label: purchasingT("SKU"),
    },
    {
      label: generalT("netQuantity"),
      infoText: salesT(
        isModifier ? "netQuantityOfModifierSold" : "netQuantityOfProductSold",
      ),
    },
    {
      label: generalT("netSales"),
      infoText: salesT(
        isModifier ? "netSalesOfModifier" : "netSalesOfProduct",
      ),
    },
    {
      label: generalT("cost"),
      infoText: salesT(
        isModifier ? "modifierCostOfGoodsSold" : "productCostOfGoodsSold",
      ),
    },
    {
      label: `${generalT("cogs")} %`,
    },
  ];

  const emptyDataArr = list.length === 0;

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            {tableHeadText.map((item) => (
              <TableCell
                align="center"
                key={item.label}
                sx={{ bgcolor: "#F9FAFB" }}
              >
                <TableHeaderCell label={item.label} infoText={item.infoText} />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        {isLoading ? (
          <TableLoadingSkeleton rowsLength={8} cellsLength={8} />
        ) : (
          <TableBody>
            {list?.map((row: any) => (
              <TableRow
                key={row.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="center">{row.menu?.name}</TableCell>
                <TableCell align="center">{row.menu?.sku}</TableCell>
                <TableCell align="center">
                  {formatNumberWithSeparators(Number(row.quantity))}
                </TableCell>
                <TableCell align="center">
                  {formatNumberWithSeparators(Number(row.price))}
                </TableCell>
                <TableCell align="center">
                  {formatNumberWithSeparators(Number(row.cost))}
                </TableCell>
                <TableCell align="center">
                  {formatNumberWithSeparators(Number(row.cogs))}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>
      {emptyDataArr && <NoData />}
    </TableContainer>
  );
};
export default TransactionItemsTable;
